<script setup lang="ts">
import { ref } from 'vue';
import { router } from '../router';
import MobileExperience from './MobileExperience.vue';
import { useGlobalStore } from '../stores/global';

const globalStore = useGlobalStore();
const loaded = ref(false);
const frame = ref<HTMLIFrameElement | null>(null);
const workspaceTools = [
  { id: 'graph', label: '⌘ Grafo', ariaLabel: 'Abrir vista de grafo', action: () => router.push('/fase-26') },
  { id: 'quality', label: '✓ Calidad', ariaLabel: 'Abrir diagnóstico de calidad', action: () => router.push('/fase-27') },
  { id: 'search', label: '⌕ Buscar', ariaLabel: 'Abrir búsqueda avanzada', action: () => router.push('/fase-28') },
  { id: 'sync', label: '☁ Sync', ariaLabel: 'Abrir sincronización', action: () => router.push('/fase-32') },
  { id: 'share', label: '👥 Compartir', ariaLabel: 'Abrir compartición de casos', action: openShare },
  { id: 'realtime', label: '⚡ Tiempo real', ariaLabel: 'Abrir colaboración en tiempo real', action: openRealtime },
  { id: 'comments', label: '💬 Comentarios', ariaLabel: 'Abrir comentarios y actividad', action: openComments },
  { id: 'commands', label: '⌘ Comandos', ariaLabel: 'Abrir paleta de comandos', action: openPalette }
];
function currentCaseId() {
  try { return (frame.value?.contentWindow as any)?.__mindplaceSyncStore?.getCurrentCaseId?.() || ''; } catch (_) { return ''; }
}
async function syncCurrentCase() {
  try {
    const bridge = (frame.value?.contentWindow as any)?.__mindplaceSyncStore;
    return Boolean((await bridge?.syncCurrentCase?.())?.ok);
  } catch (_) {
    return false;
  }
}
async function openShare() {
  const id = currentCaseId();
  await syncCurrentCase();
  router.push({ path: '/fase-38', query: id ? { caseId: id } : {} });
}
async function openRealtime() {
  const id = currentCaseId();
  await syncCurrentCase();
  router.push({ path: '/fase-39', query: id ? { caseId: id } : {} });
}
async function openComments() {
  const id = currentCaseId();
  await syncCurrentCase();
  router.push({ path: '/fase-40', query: id ? { caseId: id } : {} });
}
function openPalette() { window.dispatchEvent(new CustomEvent('mindplace:open-command-palette')); }

function handleLoad() { loaded.value = true; }
</script>

<template>
  <div class="legacy-workspace" :class="{ 'legacy-workspace--loaded': loaded }" aria-label="MindPlace">
    <iframe
      class="legacy-workspace__frame"
      ref="frame"
      title="MindPlace"
      src="/index_mejoras.html"
      allow="camera; microphone"
      @load="handleLoad"
    />
    <div v-if="!loaded" class="legacy-workspace__loading" role="status" aria-live="polite">Cargando MindPlace…</div>
    <nav class="legacy-workspace__tools" aria-label="Herramientas del espacio de trabajo">
      <button v-for="tool in workspaceTools" :key="tool.id" type="button" :aria-label="tool.ariaLabel" @click="tool.action">{{ tool.label }}</button>
    </nav>
    <MobileExperience />
    <div v-if="globalStore.legacyError" class="legacy-workspace__error" role="alert">{{ globalStore.legacyError }}</div>
  </div>
</template>

<style scoped>
.legacy-workspace { position: fixed; inset: 0; background: #111; overflow: hidden; }
.legacy-workspace__frame { display: block; width: 100%; height: 100%; border: 0; background: transparent; }
.legacy-workspace__loading, .legacy-workspace__error { position: fixed; z-index: 10; top: .75rem; left: 50%; transform: translateX(-50%); padding: .45rem .75rem; border-radius: .5rem; background: rgba(0,0,0,.78); color: #fff; font: 500 14px/1.2 system-ui, sans-serif; }
.legacy-workspace__error { top: auto; bottom: .75rem; background: #7f1d1d; }
.legacy-workspace__tools { position: fixed; z-index: 11999; top: 205px; left: 20px; display:flex; flex-direction:column; align-items:stretch; gap:.4rem; }
.legacy-workspace__tools button { border: 1px solid rgba(255,255,255,.16); border-radius: 999px; padding: .5rem .8rem; color:#fff; background: rgba(11,17,32,.82); backdrop-filter: blur(8px); cursor:pointer; font:700 13px/1 system-ui,sans-serif; }
.legacy-workspace__tools button:hover { background: rgba(28,41,61,.94); }
@media(max-width:600px){ .legacy-workspace__tools{ left:10px; top:195px; } .legacy-workspace__tools button{ font-size:12px; } }
</style>
